import type { FC } from 'react';

import { SECTION_IDS } from '@/features/home/constants/home.constants';
import { SITE_CONTAINER } from '@/features/home/constants/homeStyles.constants';
import type { ContactTile } from '@/types/home.types';

interface ContactSectionProps {
  tiles: ContactTile[];
}

const ContactSection: FC<ContactSectionProps> = ({ tiles }) => (
  <section id={SECTION_IDS.contact} className="scroll-mt-20 bg-site-bg">
    <div className={`${SITE_CONTAINER} pt-14 pb-2`}>
      <span className="mb-4 block font-site text-[13px] tracking-[0.08em] text-site-accent-deep uppercase">
        Contact us
      </span>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,240px),1fr))] gap-0.5 border-2 border-site-ink bg-site-ink">
        {tiles.map((tile) => (
          <a
            key={tile.label}
            href={tile.href}
            {...(tile.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            className="flex flex-col gap-1.5 bg-site-bg p-[22px] transition-colors hover:bg-site-accent-soft"
          >
            <span className="font-site text-[13px] tracking-[0.08em] text-site-ink/70 uppercase">
              {tile.label}
            </span>
            <span className="font-site text-[20px] font-extrabold break-words">{tile.value}</span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default ContactSection;
